module.exports = __webpack_public_path__ + "img/blog1.9313c5c1.jpg";